import { Box, Button, Card, CardContent, Checkbox, Table, TableBody, TableCell, TableRow } from '@mui/material';
import React, { useEffect, useState } from 'react';
import StaticDataService from '../../api_handlers/services/StaticDataService.ts';
import { useAppSelector } from '../../redux/hook.ts';
import VotingService from '../../api_handlers/services/VotingService.ts';
import IOption from '../../api_handlers/view_modals/IOption.ts'

const VotingCard = ({ moveToNextTeam, voteForTeamId, isSelfVoted }) => {
    const [attributes, setAttribute] = React.useState<IOption[]>([]);
    const [checked, setChecked] = useState({})
    const session = useAppSelector((state) => state.session.session);
    const loggedInTeam = useAppSelector((state) => state.team.team);

    useEffect(() => {
        const fetchAttributes = async () => {
            try {
                const data = await StaticDataService.fetchAttributes();
                setAttribute(data.data);

                const initialCheckedState = data.data.reduce((acc: { [key: string]: boolean }, attribute: IOption) => {
                    acc[attribute.key] = false;
                    return acc;
                }, {});
                setChecked(initialCheckedState);

            } catch (err) {
            }
        }
        fetchAttributes();
    }, []);


    const handleNext = () => {
        try {
            if (isSelfVoted && loggedInTeam?.id === voteForTeamId) {
                moveToNextTeam(checked);
            }
            else {
                getChecked().then((res) => {
                    if (res) {
                        console.log("Now calling Move To Next Team");
                        moveToNextTeam(checked);
                    }
                })
            }
        }
        catch (err) {
        }
    }

    const getChecked = (): Promise<Boolean> => {
        var sessionId = session?.sessionId;
        var teamId = session?.teamId;
        var userId = session?.userId;

        const result = new Promise<Boolean>(async (resolve) => {
            var keys = Object.keys(checked);
            for (var i = 0; i < keys.length; i++) {
                var attributeId = keys[i];
                await VotingService.castVote({
                    sessionId: sessionId,
                    voteByTeamId: teamId,
                    voteByUserId: userId,
                    voteForTeamId: voteForTeamId,
                    attributeId: parseInt(attributeId),
                    vote: checked[attributeId]
                });
            }
            console.log("Resolved now!!!");
            resolve(true);
        });
        return result;
    }

    const handleChange = (attribute: IOption) => {
        setChecked((prev) => ({
            ...prev,
            [attribute.key]: !prev[attribute.key],
        }));
    }

    return (
        <>
            <Box display="flex" justifyContent="space-between" flexDirection="column" alignItems="center" gap={2}>
                <Box
                    display="flex"
                    overflow="auto"
                    width="100%"
                    minHeight="250px"
                    maxHeight="400px"
                    position="relative"
                >
                    <Card variant='elevation'
                        key="id1"
                        sx={{
                            minWidth: "100%",
                            background: 'linear-gradient(135deg, rgba(139, 69, 19, 0.2) 0%, rgba(101, 67, 33, 0.8) 100%)',
                            backdropFilter: 'blur(5px)',
                            border: '0.2rem solid rgba(218, 165, 32, 0.6)',
                            borderRadius: '1rem',
                            boxShadow: '0 0.5rem 1.5rem rgba(0, 0, 0, 0.5), inset 0 0.125rem 0 rgba(255, 255, 255, 0.1)',
                        }}
                    >
                        <CardContent sx={{ padding: { xs: '1rem', md: '1.5rem' } }}>
                            <Table>
                                <TableBody>
                                    {attributes.map((attribute) => (
                                        <TableRow key={attribute.key} sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            minHeight: "3rem",
                                            padding: { xs: '0.5rem', md: '0.75rem' },
                                            borderRadius: '0.5rem',
                                            transition: 'all 0.3s ease',
                                            '&:hover': {
                                                background: 'rgba(218, 165, 32, 0.2)',
                                                transform: 'translateX(0.5rem)',
                                            }
                                        }}>
                                            <TableCell sx={{
                                                border: "none",
                                                p: 0,
                                                fontFamily: "'Philosopher', sans-serif",
                                                color: '#FFD700',
                                                fontSize: { xs: '1rem', md: '1.15rem' },
                                                fontWeight: 600,
                                                textShadow: '0.1rem 0.1rem 0.2rem rgba(0,0,0,0.7)',
                                            }}>
                                                {attribute.value}
                                            </TableCell>
                                            <TableCell sx={{ border: "none", p: 0 }}>
                                                <Checkbox
                                                    checked={checked[attribute.key]}
                                                    onChange={(e) => handleChange(attribute)}
                                                    sx={{
                                                        color: 'rgba(218, 165, 32, 0.7)',
                                                        '&.Mui-checked': {
                                                            color: '#FFD700',
                                                        },
                                                        '& .MuiSvgIcon-root': {
                                                            fontSize: { xs: '1.5rem', md: '1.75rem' },
                                                            filter: 'drop-shadow(0 0 0.5rem rgba(255, 215, 0, 0.5))',
                                                        }
                                                    }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </CardContent>
                    </Card>
                </Box>
                <Box width="100%" display="flex" justifyContent="flex-end" mt={1}>
                    <Button variant="contained" onClick={handleNext} sx={{
                        padding: { xs: '0.75rem 2rem', md: '0.875rem 2.5rem' },
                        fontSize: { xs: '1rem', md: '1.125rem' },
                        fontFamily: "'Cinzel', serif",
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #DAA520 0%, #B8860B 100%)',
                        border: '0.15rem solid rgba(255, 215, 0, 0.6)',
                        borderRadius: '0.75rem',
                        boxShadow: '0 0.25rem 1rem rgba(218, 165, 32, 0.4), inset 0 0.0625rem 0 rgba(255, 255, 255, 0.3)',
                        textTransform: 'uppercase',
                        letterSpacing: '0.08rem',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            background: 'linear-gradient(135deg, #FFD700 0%, #DAA520 100%)',
                            boxShadow: '0 0.5rem 1.5rem rgba(218, 165, 32, 0.6), inset 0 0.0625rem 0 rgba(255, 255, 255, 0.4)',
                            transform: 'translateY(-0.125rem)',
                        },
                        '&:active': {
                            transform: 'translateY(0)',
                        }
                    }}>
                        Submit
                    </Button>
                </Box>
            </Box>
        </>
    )
}
export default VotingCard;